// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-9f7840f2] .custom-control-label:before {\n  left: -20px;\n  top: 2px;\n}\n[data-v-9f7840f2] .custom-control-label:after {\n  left: -20px;\n  top: 2px;\n}", ""]);
// Exports
module.exports = exports;
